package pl.decks.personal.components.widgets.ranks

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.times
import pl.decks.personal.components.animations.AppearAnimation

@Composable
fun RanksPreview(ranks: List<Rank>, modifier: Modifier = Modifier) = Column(
    modifier = RanksStylesheet.Preview.toModifier().then(modifier),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    RankingSystemSlotsScrollIndicator()
    RanksPreviewSlots(ranks)
}

@Composable
private fun RankingSystemSlotsScrollIndicator() = Row(
    modifier = Modifier.fillMaxWidth(),
    verticalAlignment = Alignment.CenterVertically,
    horizontalArrangement = Arrangement.SpaceBetween,
) {
    FaChevronLeft()
    SpanText("Scroll/Swipe", modifier = RanksStylesheet.InstructionText.toModifier())
    FaChevronRight()
}

@Composable
private fun RanksPreviewSlots(ranks: List<Rank>) = Row(RanksStylesheet.Slots.toModifier()) {
    ranks.forEachIndexed { index, rank ->
        SlotRank(
            rank,
            modifier = Modifier.animation(
                AppearAnimation.Frames.toAnimation(
                    duration = RanksStylesheet.Vars.appearDuration.value(),
                    timingFunction = AnimationTimingFunction.EaseOut,
                    delay = RanksStylesheet.Vars.appearPositionDelay.value() * index,
                    fillMode = AnimationFillMode.Both,
                )
            )
        )
    }
}
